import { Typography } from "@suraasa/placebo-ui"
import { useQuery } from "@tanstack/react-query"
import api from "api"
import { queries } from "api/queries"
import { useParams } from "react-router-dom"

import { useQualificationDetails } from ".."
import CertificateActionButtons from "./CertificateActionButtons"
import CertificateContactUs from "./CertificateContactUs"
import SuraasaCertificateCard from "./SuraasaCertificateCard"

const QualificationCertificates = () => {
  const { slug, learningItemType } = useParams() as {
    slug: string
    learningItemType: string
  }

  const { qualification } = useQualificationDetails()

  const { data } = useQuery({
    queryKey: queries.credentials.getUserCredentials(
      learningItemType,
      qualification.id
    ).queryKey,
    queryFn: () =>
      api.credentials.getUserCredentials({
        urlParams: { itemType: learningItemType, itemId: qualification.id },
      }),
  })

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-1">
        <Typography variant="title3">Certificates</Typography>
        {data?.serialNumber && (
          <CertificateActionButtons
            slug={slug}
            learningItemType={learningItemType}
          />
        )}
      </div>
      <SuraasaCertificateCard
        serialNumber={data?.serialNumber}
        slug={slug}
        learningItemType={learningItemType}
      />
      <CertificateContactUs />
    </div>
  )
}

export default QualificationCertificates
